import { render, staticRenderFns } from "./SalesContract.vue?vue&type=template&id=70d2a9b3"
import script from "./SalesContract.vue?vue&type=script&lang=js"
export * from "./SalesContract.vue?vue&type=script&lang=js"
import style0 from "./SalesContract.vue?vue&type=style&index=0&id=70d2a9b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports